import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import useShrink from '@hook/useShrink';
import { NAV_LIST } from '@helpers/NavHalper';
import {
  useEventListener,
  useOnClickOutside,
  useLockedBody,
  useWindowSize,
} from 'usehooks-ts';

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageBox from '@organisms/common/LanguageBox';
import MainStoreBtn from '@atoms/btn/MainStoreBtn';
import SNSList from '@molecules/SNSList';
import { getPathName } from '@helpers/StringHelper';

const MobileMenu = ({ handleClose }) => {
  const [select, setSelect] = useState('');
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const pathname = getPathName(location.pathname);
  const onMenuClick = menu => {
    setSelect(menu);
  };
  const onClickMenuLink = (e, nav, link, childLength) => {
    e.preventDefault();

    if (childLength <= 0) {
      navigate(link);
      handleClose(e);
    }
  };

  return (
    <ul>
      {NAV_LIST.map((nav, idx) => {
        return (
          <li
            onClick={() => onMenuClick(nav.nav)}
            className={classnames({
              active:
                ((pathname == '' ||
                  pathname == '/' ||
                  pathname == '/' + i18n.language) &&
                  nav.nav == 'GAME') ||
                pathname === `/${i18n.language}${nav.link}` ||
                pathname.includes(nav.link),
            })}
            key={`nav_${idx}`}
          >
            <div className="menu-wrap ">
              <a
                href="#"
                className="flex  justify-between align-middle "
                onClick={e =>
                  onClickMenuLink(
                    e,
                    nav.nav,
                    `/${i18n.language}${nav.link}`,
                    nav.child ? nav.child.length : 0
                  )
                }
              >
                <img
                  src={`/img/v2/mobile/gnb_bullet_0${idx + 1}.png`}
                  className="h-[22px] active-icon invisible "
                />
                <span>{t(nav.title)}</span>
                <img
                  src={`/img/v2/mobile/gnb_bullet_0${idx + 1}.png`}
                  className="h-[22px] active-icon invisible"
                />
              </a>
              <div></div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

const HeaderMobile = props => {
  const ref = useRef(null);
  const isShrink = useShrink(4);
  const [show, setShow] = useState(false);

  const [locked, setLocked] = useState(false);
  const { width } = useWindowSize();

  const { t, i18n } = useTranslation();
  const location = useLocation();

  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 0) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEventListener('resize', () => {
    if (width > 980) {
      setShow(false);
      setLocked(false);
    }
  });

  const handleOpen = e => {
    e.preventDefault();
    setShow(true);
    setLocked(true);
  };
  const handleClose = e => {
    // e.preventDefault();
    setShow(false);
    setLocked(false);
  };

  useOnClickOutside(ref, handleClose);
  useLockedBody(locked);

  return (
    <div
      {...props}
      id="mobile-menu-wrap"
      className={classnames({ 'scroll-on': scroll })}
    >
      <div className={classnames('overlay', { on: show })}></div>
      <div className={classnames('background-overlay', { on: true })}></div>
      <h1 className="logo">
        <a href="/">
          <img
            src={`/img/v2/logo-350-${
              ['kr', 'en', 'jp'].includes(i18n.language) ? i18n.language : 'kr'
            }.png`}
          />
        </a>
      </h1>
      {/* <!-- open menu btn --> */}
      <button className="gnb-toggle-btn" onClick={handleOpen}>
        <span></span>
      </button>
      <div ref={ref} className={classnames(' m-menu', { on: show })}>
        {/* <!-- close menu btn --> */}
        <button className="gnb-toggle-btn close" onClick={handleClose}></button>
        <nav id="m-gnb">
          <MobileMenu handleClose={handleClose} />
          <div className="info-group">
            <LanguageBox />
          </div>
          <MainStoreBtn />
          <SNSList />
        </nav>
        <div className="bg-[#f7f7f7] w-full p-3 absolute bottom-0 left-0 text-center">
          <img
            src={`/img/v2/logo-type2-${
              ['kr', 'en', 'jp'].includes(i18n.language) ? i18n.language : 'kr'
            }.png`}
            className="h-[30px] inline-block"
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderMobile;
